import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import { AuthContext } from "../contexts/AuthContext";
import moment from "moment";
import BookingSlider from "./BookingSlider";
import Loader from "./Loader";
import axiosHttp from "../config/axios.interceptor";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import { useDispatch } from "react-redux";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import undrawProfile from "../img/undraw_profile.svg";
import { errorResponseMessage } from "../shared/const.prop";

const RescheduleSession = ({ data }) => {
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const { user } = authContext;
  const {
    service_id,
    service_name,
    amount,
    expertise,
    mentor_id,
    appointment_id,
  } = data;
  const [bookingsList, setBookingsList] = useState([]);
  const [slotIndex, setSlotIndex] = useState();
  const [loading, setLoading] = useState(true);
  const [slot, setSlot] = useState({
    date: "",
    time: {},
  });
  const [slotDate, setSlotDate] = useState(moment().format("YYYY-MM-DD"));
  const [min, setMin] = useState();
  const [max, setMax] = useState();
  const [duration, setDuration] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [scheduleList, setScheduleList] = useState();
  const [availableDates, setAvailableDates] = useState([]);
  const [zoneId, setZoneId] = useState();
  const [timeZone, setTimeZone] = useState("");
  const [current, setCurrent] = useState(moment().format("YYYY-MM"));
  const { id } = useParams();
  const navigate = useNavigate();
  // const [slotObj, setSlotObj] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const userId = user?.userId || user?.data?.data?.userId;

  var isMentor = localStorage.getItem("userId") === data?.mentor_id;

  const myZone = localStorage.getItem("zone");

  useEffect(() => {
    getTimeZone();

    dispatch(getActiveNotificationCount());
    dispatch(getActiveChatNotificationCount());
  }, []);

  const getTimeZone = async () => {
    try {
      const timeZone = await axiosHttp.get(`timezone`);
      if (timeZone.status === 200) {
        let data = timeZone?.data?.data;
        const myTimeZone = data.find((item) => {
          const { utc } = item;
          return utc.includes(myZone);
        });
        setTimeZone(myTimeZone?.utc[0]);
        setZoneId(myTimeZone?._id?.$oid);

        fetchBookings(myTimeZone?._id?.$oid, slotDate);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }

      setLoading(false);
    }
  };

  const fetchBookings = async (zoneId, slotDate) => {
    let formattedDate = moment(slotDate).format("YYYY-MM-DD");
    const end = moment(slotDate).add(3, "months").format("YYYY-MM-DD");
    try {
      const getBookingsList = await axiosHttp.get(
        `services/${service_id}/new-slots?zone=${zoneId}&startDate=${formattedDate}T00:00:00z&endDate=${end}T00:00:00z`
      );
      if (getBookingsList.status === 200) {
        let data = getBookingsList?.data?.data;
        let filteredData = data.find((item) => {
          return moment(item.date).format("YYYY-MM-DD") === formattedDate;
        });
        let filteredSlots = filteredData?.slots || [];
        setBookingsList(filteredSlots);

        service_name === "Single session"
          ? fetchAvailableDates(current, zoneId)
          : fetchSlotDates(current, zoneId);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 422) {
        service_name === "Single session"
          ? fetchAvailableDates(current, zoneId)
          : fetchSlotDates(current, zoneId);
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }

      console.log(e);
      setBookingsList([]);
      setLoading(false);
    }
  };

  const fetchAvailableDates = async (current, zoneId) => {
    try {
      const getSlotList = await axiosHttp.get(
        `services/${service_id}/date?zone=${zoneId}&date=${current}-01`
      );
      if (getSlotList.status === 200) {
        let data = getSlotList?.data?.data;
        let available = [];
        data.map((item) => {
          available.push(item.date);
        });
        setAvailableDates(available);
        setLoading(false);
      }
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setLoading(false);
    }
  };

  const fetchSlotDates = async () => {
    try {
      const slotDateList = await axiosHttp.get(
        `weekly-appointment-queries?appId=${appointment_id}`
      );
      if (slotDateList.status === 200) {
        let data = slotDateList?.data.data;
        let available = [];
        data.map((item) => {
          available.push(item.dates);
        });
        setAvailableDates(available.flat());
        // setSlotObj(data);
        setLoading(false);
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response.status === 422) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      setAvailableDates([]);
      setLoading(false);
    }
  };

  const startTimeMoment = moment(data?.start_time);
  const endTimeMoment = moment(data?.end_time);

  const formattedDate = startTimeMoment.format("Do MMMM");
  const formattedTime = `${startTimeMoment.format(
    "h:mmA"
  )} - ${endTimeMoment.format("h:mmA")}`;

  const fetchAvailability = async () => {
    try {
      const getAvailabilityList = await axiosHttp.get(
        `users/${mentor_id}/queries?status=Answered`
      );
      let data = getAvailabilityList?.data?.data.filter(
        (item) => item.serviceId === service_id
      );
      setStartDate(new Date(data[0].start_date));
      setEndDate(new Date(data[0].end_date));
      setDuration(data[0].duration.split(" ")[0]);
      fetchUserSchedule();
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const fetchUserSchedule = async () => {
    try {
      const getSchedule = await axiosHttp.get(`users/${mentor_id}/schedule`);
      let data = getSchedule?.data?.data?.schedule;
      setScheduleList(data);
      setLoading(false);
    } catch (error) {
      if (error.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
        authContext.logout();
      }
      if (error.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(error),
          type: "error",
        });
      }
      if (error.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
    }
  };

  const handleSlotDate = (nextValue) => {
    let formattedDate = moment(nextValue).format("YYYY-MM-DDTHH:mm:ss[Z]");
    setSlotDate(formattedDate);
    fetchBookings(zoneId, formattedDate);
  };

  const handleTimeSlot = (item) => {
    setSlot({ ...slot, time: item });
  };

  const handleEvent = (event, picker) => {
    setStartDate(picker.startDate._d.toISOString());
    setEndDate(picker.endDate._d.toISOString());
  };

  const formatTime = (time) => {
    return moment.utc(time).format("h:mm A");
  };

  const rescheduleHandler = async () => {
    setIsSubmit(true);
    let payload = {
      userId: data?.mentor_id,
      serviceId: service_id,
      startTime: slot?.time?.utcStartTime,
      endTime: slot?.time?.utcEndTime,
      comment: reason,
      zone: timeZone,
    };
    try {
      const rescheduleSlot = await axiosHttp.post(
        isMentor
          ? `reschedule-request/${data.id}`
          : `reschedule-appointment/${data.id}`,
        {
          ...payload,
        }
      );
      if (rescheduleSlot.status === 201) {
        let data = rescheduleSlot?.data;
        appContext.updateNotificationState({
          type: "success",
          message: isMentor
            ? "Booking reschedule request initiated"
            : "Booking reschedule successful",
          show: true,
        });
        setIsSubmit(false);
        dispatch(getActiveNotificationCount());
        let test = {
          name: "rescheduleSession",
          appId: appointment_id,
          serviceName: service_name,
        };
        appContext.updateModalState(test);
        appContext.updateAppId(data?.appId);
        navigate(`../myspace/schedule/${appointment_id}`, {
          state: { serviceName: service_name },
        });
        // navigate("../myspace/schedule");
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      console.log(e);
    }
    setIsSubmit(false);
  };

  const rescheduleWeeklyHandler = async () => {
    let payload = {
      userId: id,
      serviceId: service_id,
      startTime: startDate,
      endTime: endDate,
      expertise: expertise,
      duration: duration,
      comment: reason,
    };
    try {
      const slotBook = await axiosHttp.post(`book-weekly-appointment`, {
        ...payload,
      });
      if (slotBook.status === 200) {
        const data = slotBook?.data;
        appContext.updateNotificationState({
          type: "success",
          message: data.message,
          show: true,
        });
        dispatch(getActiveNotificationCount());
        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      } else {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      //console.log(e);
      setLoading(false);
    }
  };

  const tileDisabled = ({ date }) => {
    const formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss[Z]");
    return !availableDates.includes(formattedDate) ? true : null;
  };

  const isSMEProfile = () => {
    if (isMentor) {
      return data?.mentee_offer_service || false;
    } else {
      return data?.mentor_offer_service || false;
    }
  };

  return loading ? (
    <Loader />
  ) : isSubmit ? (
    <div className="join-session-modal">
      <div className="modal-header">
        <h3 className="w-100 text-center mb-0">Reschedule</h3>
      </div>
      <div className="modal-body">
        <p>
          Your reschedule request has been initiated, please wait while we are
          processing...
        </p>
      </div>
    </div>
  ) : (
    <div className="join-session-modal">
      <div className="modal-header">
        <h3 className="w-100 text-center mb-0">Reschedule</h3>
      </div>
      <div className="modal-body">
        <div
          className="d-flex ml-2 align-items-start"
          id="exampleModalLongTitle"
        >
          <div className="sme-profile">
            <img
              className={`img-profile rounded-circle mr-3 ${
                isSMEProfile() ? "sme-mini-service" : null
              }`}
              src={
                isMentor
                  ? data?.mentee_pic_url
                  : data?.mentor_pic_url || undrawProfile
              }
              onClick={() => {
                navigate(
                  `../${
                    isMentor ? data?.mentee_user_name : data?.mentor_user_name
                  }`
                );
              }}
            />
            {isSMEProfile() && <div className="sme-mini-icon">SME</div>}
          </div>
          <div>
            <span
              className="profile-name reschedule-profile-name"
              onClick={() => {
                navigate(
                  `../${
                    isMentor ? data?.mentee_user_name : data?.mentor_user_name
                  }`
                );
              }}
            >
              {isMentor
                ? data?.mentee_name
                : data?.mentor_name || undrawProfile}
            </span>
            <p className="mb-0">
              <strong>Session Details:</strong>
            </p>
            <p className="mb-0">
              <strong>Service Name: </strong> {data?.service_name}
              <br />
              <strong>Date: </strong> {formattedDate}
              <br /> <strong>Time: </strong>
              {formattedTime}
              <br />
              <strong>Call: </strong>{" "}
              {data?.appointment_type ? data?.appointment_type : "1:1"}
            </p>
          </div>
        </div>

        <div class="form-group mt-3">
          <lable>
            <strong>Reason</strong>
          </lable>

          <select
            className="form-control"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          >
            <option value="">Select</option>
            <option value="Personal reasons">Personal reasons</option>
            <option value="Expertise request for reschedule">
              Expertise request for reschedule
            </option>
            <option value="Connect button not visible">
              Connect button not visible
            </option>
            <option value="My network down">My network down</option>
            <option value="Application was not able to connect">
              Application was not able to connect
            </option>
            <option value="Others">Others</option>
          </select>
        </div>

        <Calendar
          onChange={handleSlotDate}
          value={slotDate}
          className="custom-calendar"
          tileDisabled={tileDisabled}
        />
        {service_name === "Single session" &&
        (bookingsList.length === 0 || bookingsList === undefined) ? (
          <p>No slots available</p>
        ) : (
          <BookingSlider
            bookingsList={bookingsList}
            slotIndex={slotIndex}
            handleTimeSlot={handleTimeSlot}
            slot={slot}
            service={service_name}
            slotDate={slotDate}
          />
        )}
      </div>

      <div className="modal-footer mt-2 mb-3">
        <button
          type="button"
          className="btn btn-outline-primary prime-btn"
          data-dismiss="modal"
          onClick={() => appContext.updateModalState()}
        >
          Cancel
        </button>

        <div className="text-right mr-2">
          <button
            className="btn btn-outline-primary modal-btn"
            disabled={reason === "" || Object.keys(slot.time).length === 0}
            onClick={rescheduleHandler}
          >
            {isMentor ? "Send" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RescheduleSession;
